module.exports = __webpack_public_path__ + "static/media/211AI007.fff2d53c.jpg";